module.exports = __webpack_public_path__ + "static/img/qq.c4359e77.png";